import {
  Form, 
  ButtonGroup, 
  Button, 
  Label
} from 'reactstrap';
import './layout.css';

function PerformTrainingPageControls(props){
  const{
    playingMedia,
    description,
    handleDecreaseSpeedClick,
    decreaseDisabled,
    handleIncreaseSpeedClick,
    increaseDisabled,
    isPlaying,
    handleMediaControlClick,
    previousDisabled,
    replayDisabled,
    handleRestartClick,
    handlePreviousClick,
    handleReplayClick,
    nextDisabled,
    hideSpeedControls,
    handleNextClick
  } = props;
  console.log("PerformTrainingPageControls with: ", props);
  return (
    <>
    <Form className='instruct-control-container'>
      {playingMedia && isPlaying ? 
        <ButtonGroup className='instruct-control-bar' size='lg'>
          {!hideSpeedControls && <Button className='instruct-control-button' disabled={decreaseDisabled} onClick={() => handleDecreaseSpeedClick()}>Decrease Speed</Button>}
          <Label className='instruct-control-label'>{description}</Label>
          {!hideSpeedControls && <Button className='instruct-control-button' disabled={increaseDisabled}  onClick={() => handleIncreaseSpeedClick()}>Increase Speed</Button>}
          <Button className='instruct-control-button' color='primary' onClick={() => handleMediaControlClick(false)}>Pause</Button>
        </ButtonGroup>
      :
      <ButtonGroup className='instruct-control-bar' size='lg'>
          {!previousDisabled && <Button className='instruct-control-button' disabled={previousDisabled}  onClick={() => handleRestartClick()}>Restart Training</Button>}
          {!previousDisabled && <Button className='instruct-control-button' disabled={previousDisabled}  onClick={() => handlePreviousClick()}>Previous Step</Button>}
          {!replayDisabled && <Button className='instruct-control-button' disabled={replayDisabled} onClick={() => handleReplayClick()}>Replay Step</Button>}
          {playingMedia && <Button className='instruct-control-button' color={playingMedia ? 'primary' : 'secondary'} disabled={!playingMedia} onClick={() => handleMediaControlClick(false)}>Play</Button>}
          {!nextDisabled && <Button className='instruct-control-button' color={playingMedia ? 'secondary' : 'primary'} disabled={nextDisabled}  onClick={() => handleNextClick()}>Next</Button>}
      </ButtonGroup>
      }
    </Form>
    </>
  );
}

export {PerformTrainingPageControls};
